
import MapCommand from './MapCommand';

export default class MapCommandSetCenter extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'SET_CENTER';
    }

    execute(olMap, params) {
        olMap.setCenter([params.x, params.y]);
        if (params.zoom) {
            olMap.setZoom(params.zoom);
        }
    }
}
